import { createContext } from 'react';

export const FSContext = createContext()